
<template lang="html">
    <div v-if="anytimeWidget && anytimeWidget.meeting && !(minutes <= 0 && seconds <= 0)">
        <div class="sidebar__widget-area">
            <div class="sidebar__widget-title">Ședință acum:</div>

            <div class="anytime-widget anytime-widget--pending" @click="isOpen = true">
                <div class="anytime-widget__specialist-img">
                    <img v-if="user.role == 'client'" 
                        :src="anytimeWidget.otherUser.image_url" 
                        :alt="anytimeWidget.otherUser.full_name"
                    />
                    <img v-else src="@/assets/images/person-icon.png" alt="User image"/>
                </div>
                <div class="anytime-widget__text">
                    <!-- <span> {{ minutes }} min rămase </span>  -->
                    
                    <span>
                         <i class="fas fa-hourglass-half"></i> {{(minutes < 10) ? '0'+minutes : minutes}}:{{(seconds < 10) ? '0'+seconds : seconds}} | Reintră
                    </span>
                    
                    <span>
                        {{ anytimeWidget.otherUser.full_name }}
                    </span>
                </div>
            </div>
        </div>
        <audio style="display: none;" preload="none" id="appointment-starting-audio">
            <source src="@/assets/audio/appointmentstarting.mp3" type="audio/mpeg">
        </audio>
        
        <AnytimeMeetingReentryModal v-if="isOpen" @close="isOpen = false"
            :minutes="minutes" :seconds="seconds" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config.js';
import * as moment from 'moment';

import AnytimeMeetingReentryModal from '@/layouts/Dashboard/components/AnytimeMeetingReentryModal'
export default {
    components: { AnytimeMeetingReentryModal },
    data() {
        return {
            minutes: 0,
            seconds: 0,
            timeText: '',
            timerInterval: null,
            remainingTime: 0,
            isOpen: false
        };
    },
    mounted() {
        this.setTimer();
    },
    computed: {
        ...mapGetters({
            anytimeWidget: 'layout/anytimeWidget',
            user: 'user/user'
        })
    },
    methods: {
        ...mapActions({
            
        }),
        // specialistProfile() {
        //     if(this.anytimeWidget.otherUser.role == 'specialist')
        //         this.$router.push('/specialists/profile/'+ this.anytimeWidget.otherUser.id);
        // },
        setTimerText(date) {
            const start = moment(date.getTime());
            this.timeText = moment.duration(moment().diff(start)).humanize();
        },
        
        setTimer() {
            var enterTime = null; var meeting = this.anytimeWidget.meeting;
            
            if(!meeting.client_joined_at && !meeting.specialist_joined_at)
                enterTime = new Date(this.anytimeWidget.meeting.created_at).getTime();
                
            else if(meeting.client_joined_at && !meeting.specialist_joined_at)
                enterTime = new Date(meeting.client_joined_at).getTime();
            
            else if(!meeting.client_joined_at && meeting.specialist_joined_at)
                enterTime = new Date(meeting.specialist_joined_at).getTime();
            
            else {
                var specialistJoinedAt = new Date(meeting.specialist_joined_at).getTime();
                var clientJoinedAt = new Date(meeting.client_joined_at).getTime();
                if (clientJoinedAt > specialistJoinedAt)
                    enterTime = clientJoinedAt;
                else enterTime = specialistJoinedAt;
            }
            
            this.remainingTime = meeting.duration * 60000 - (new Date().getTime() - enterTime);
            
            this.minutes += Math.floor(this.remainingTime / 60000);
            this.seconds = ((this.remainingTime % 60000) / 1000).toFixed(0);
            
            this.timerInterval = setInterval(() => {
                if(this.minutes <= 0 && this.seconds <= 0) {
                    clearInterval( this.timerInterval );
                    this.$store.state.layout.anytimeWidget.meeting = null;
            
                } else if (this.seconds == 0) {
                    this.minutes -= 1;
                    this.seconds = 59;
                } else {
                    this.seconds = Number(this.seconds) - 1;
                }
            }, 1000);
        }
    },
    destroyed() {
        clearInterval( this.timerInterval );
    }
}
</script>

<style lang="scss">
    .anytime-widget{
        background-color: $color-secondary;
        padding: 15px 0px;
        margin-top: 20px;
        text-align: center;
        font-weight: 500;
        border-radius: 25px;
        color: white;
        max-width: 245px;
        position: relative;
        
        &--pending{
            span:last-of-type{
                display: none;
            }

            &:hover{
                span:first-of-type{
                    display: none;
                }

                span:last-of-type{
                    display: block;
                    cursor: pointer;
                }
                i{
                    display: none;
                }
            }
        }

        &--processing{
            background-color: $color-warning;
        }

        &--ready{
            background-color: #00CD98;
        }

        &__specialist-img{
            position: absolute;
            left: 4px;
            top: 50%;
            transform: translate(0%, -50%);
            height: 40px;
            width: 40px;
            max-height: 40px;
            max-width: 40px;
            border-radius: 50%;
            background-color: white;
            border: 1px solid white;
            overflow: hidden;
            display: flex;

            img{
                object-fit: cover;
                width: 100%;
                height: 100%;
                margin: auto;
            }
        }
    }
</style>